import { instance } from "apis/interceptor";
import { TViolationRsvListItem } from "pages/meeting/MeetingRoomManage/MinimumAttendeesManagement/ViolationReservations/types";

type ViolationListResponse = {
  totalSearchNumber: number;
  totalPageNumber: number;
  nowPageNumber: number;
  attendeeLimitViolationList: TViolationRsvListItem[];
};

type ResponseType<T> = {
  success: boolean;
  message?: string;
  data?: T;
};

//* INFO: 최소 참석 인원 위반 예약 조회
export const getViolationRsvList = async (
  startDate: Date,
  endDate: Date,
  nowPageNumber: number
): Promise<ResponseType<ViolationListResponse>> => {
  try {
    const res = await instance.post("/meetings/attendee-limit-violation/list", {
      nowPageNumber: nowPageNumber,
      viewStartDate: startDate,
      viewEndDate: endDate,
    });
    return { success: true, data: res.data };
  } catch (error: any) {
    if (error.response?.status === 403) {
      return { success: false, message: "최소 참석 인원 관리 페이지의 권한이 없습니다." };
    } else return { success: false, message: "최소 참석 인원 위반 예약 조회를 실패하였습니다." };
  }
};
